var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestions = function SvgQuestions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 67 68"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#questions_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.696 39.487c.04-2.335.305-4.193.796-5.546s1.5-2.866 3.012-4.525l3.875-3.98c1.658-1.872 2.494-3.888 2.494-6.025 0-2.136-.544-3.688-1.632-4.856s-2.667-1.765-4.737-1.765-3.622.53-4.843 1.606c-1.22 1.074-1.844 2.494-1.844 4.285H20.35q.053-4.79 3.41-7.735T32.504 8q5.6 0 8.718 2.999c2.083 2.003 3.118 4.737 3.118 8.227s-1.592 6.846-4.79 10.19l-3.224 3.198q-2.163 2.388-2.163 6.873zm-.239 9.408c0-.902.265-1.645.81-2.256.544-.61 1.353-.915 2.415-.915q1.591 0 2.428.915a3.25 3.25 0 0 1 .822 2.256 3.18 3.18 0 0 1-.822 2.23q-.837.875-2.428.875c-1.062 0-1.871-.292-2.415-.876s-.81-1.34-.81-2.229M47.938 35.33c.2-.77.438-1.366.704-1.778s.73-.836 1.366-1.26l1.606-1.022c.703-.49 1.14-1.088 1.3-1.805s.12-1.273-.146-1.738c-.265-.464-.743-.796-1.433-.968-.69-.173-1.247-.107-1.738.146-.491.252-.81.69-.955 1.287l-1.818-.438q.398-1.593 1.751-2.309c.902-.464 1.938-.557 3.132-.279 1.194.279 2.136.863 2.667 1.686.53.822.663 1.83.385 2.985-.28 1.154-1.075 2.15-2.402 3.012l-1.327.796c-.61.425-1.035 1.128-1.274 2.123zm-.822 3.105c.06-.274.22-.516.45-.676q.346-.24.877-.12c.345.093.597.252.73.504a1.06 1.06 0 0 1 .092.81.994.994 0 0 1-1.327.77c-.358-.08-.597-.24-.73-.478a1.05 1.05 0 0 1-.092-.81m-30.852-4.484c-.066.49-.013 1.127.146 1.91l1.831-.398c-.225-1.008-.159-1.818.213-2.468l.836-1.3c.822-1.354 1.101-2.6.849-3.755s-.796-1.99-1.645-2.508c-.85-.518-1.938-.624-3.132-.358-1.194.265-2.11.796-2.707 1.618s-.783 1.765-.57 2.84l1.83-.398c-.132-.61-.039-1.141.293-1.579s.796-.743 1.5-.89c.702-.145 1.26-.079 1.71.24.452.318.744.783.903 1.5.16.716.04 1.445-.385 2.202l-.995 1.605c-.385.664-.61 1.248-.677 1.739m.863 4.259a1.12 1.12 0 0 0-.106.81c.054.273.21.515.438.676q.345.24.875.12a1.1 1.1 0 0 0 .743-.478 1.03 1.03 0 0 0 .107-.796 1.1 1.1 0 0 0-.438-.69c-.226-.173-.518-.213-.876-.133a1.06 1.06 0 0 0-.743.491",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "questions_svg__a",
    width: 66.898,
    height: 68,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5541_3373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5541_3373",
    result: "shape"
  })))));
};
export default SvgQuestions;